module.exports = __webpack_public_path__ + "img/manheim-logo.f2878a59.png";